<template>
  <div>
    <v-row>
      <v-col align="end">
        <mf-tooltip :disabled="hasPiiAccess && !hasEnqueuedCashback" max-width="250" top content-class="truncated-tooltip">
          <template #activator="{ on }">
            <mf-button :disabled="!hasPiiAccess || hasEnqueuedCashback" label="Ajustar cashback" @click="openAdjustCashbackDialog()" />
          </template>
          <span v-if="hasEnqueuedCashback"
            >Alguns ajustes de cashback estão sendo realizados no momento. Aguarde alguns instantes para realizar essa ação novamente.</span
          >
          <span v-else-if="!hasPiiAccess">Você precisa ter a permissão de acesso a informações privilegiadas para acessar esse recurso.</span>
        </mf-tooltip>
      </v-col>
    </v-row>

    <cashback-adjustments-table ref="cashbackTable" />
    <adjust-cashback-dialog v-model="adjustCashbackDialogIsOpen" @adjust="reloadTable" />
  </div>
</template>

<script>
import CashbackAdjustmentsTable from '@/modules/mobile/cashback/views/components/CashbackAdjustmentsTable.vue'
import AdjustCashbackDialog from '@/modules/mobile/cashback/views/components/AdjustCashbackDialog.vue'
import { mapState } from 'vuex'

export default {
  name: 'CashbackAdjustments',

  components: {
    CashbackAdjustmentsTable,
    AdjustCashbackDialog,
  },

  data: () => ({
    adjustCashbackDialogIsOpen: false,
  }),

  computed: {
    hasPiiAccess() {
      return this.$hasPiiAccess()
    },
    ...mapState({
      hasEnqueuedCashback: (state) => state.hasEnqueuedCashbackAdjustmentReport,
    }),
  },

  methods: {
    openAdjustCashbackDialog() {
      this.adjustCashbackDialogIsOpen = true
    },
    reloadTable() {
      this.$refs.cashbackTable.reload()
    },
  },
}
</script>
